import React, { useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { CustomTable } from './CustomTable';

export const DistrictSelectPopUp = ({ isOpen, handleClose, storeSelectedDistricts, operatorId, districtIds, districts, setDistricts, selectAll, setSelectAll, selectDistrict }) => {
	const [selectedDistricts, setSelectedDistricts] = useState<any[]>(districtIds);

	const handleSelect = () => {
		storeSelectedDistricts(selectedDistricts);
		handleClose();
    };

	const select = (item) => {
		let list = Array.from(selectedDistricts);
		if(selectedDistricts.some(x => x.id === item.id)){
			var newList = list.filter(x => x.id !== item.id)
			setSelectedDistricts(newList)
		} else {
			list.push(item)
			setSelectedDistricts(list)
		}
	}

	const selectEverything = () => {
		if(selectedDistricts.length === districts.length){
			setSelectedDistricts([])
		} else {
			setSelectedDistricts(districts)
		}
	}

	return (
		<Dialog fullWidth onClose={handleClose} open={isOpen}>
		<DialogContent style={{ padding: "0px" }}>
			<CustomTable
				columns={[
					{
					title: <input type="checkbox" checked={selectedDistricts.length === districts.length} onClick={() => selectEverything()} />,
					field: '',
					render: rowData => <input type="checkbox" checked={selectedDistricts.some(x => x.id === rowData.id)} onClick={() => select({id: rowData.id, name: rowData.name })} /> },
					{ title: 'District', field: 'code', render: rowData => rowData.code },
					{ title: 'Name', field: 'name' }
				]}
				dataEndpoint={null}
				dataSet={districts}
				pageSize={15}
				enablePaging={true}
				refresh={false}
				setRefresh={null}
				title={""}
				districtId={null}
				actions={[]}
				hiddenColumns={[]}
				setHiddenColumns={() => {}}
				hiddenColumnsDisabled={true}
				addedQuery={null}
				tableHeight={"400px"}
				enableSearch={false}
				searchPlaceholder={null} />
			<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0px' }}>
				<button className='uvp-button green-button' 
					style={{
						margin: "10px",
						padding: "5px 10px"
					}}
					onClick={handleSelect}>
					Select
				</button>
				<button
					className='uvp-button gray-button'
					style={{
						margin: "10px",
						padding: "5px 10px"
					}}
					onClick={handleClose}>
					Close
				</button>
			</div>
			
		</DialogContent>
		</Dialog>
	);
};